const isValidFaqQuestion = (q: any) => {
  const { question, url } = q;
  if (!question || !url) return false;
  return typeof question === 'string' && typeof url === 'string';
};

export default isValidFaqQuestion;
